/**
 * Room naming utilities for Socket.IO real-time entities.
 *
 * Delegates to SDK entityRoom() for building room names.
 * Provides parsing utilities used only by the backend.
 */

// Re-export SDK helper as the canonical room builder
export { entityRoom } from '@gzl10/nexus-sdk'

/**
 * Checks whether a room name is a tenant-scoped entity room.
 * Format: `entity:{tenantId}:{module}.{entity}`
 */
export function isEntityRoom(room: string): boolean {
  return room.startsWith('entity:')
}

/**
 * Parses tenantId, module and entity from a room name.
 * Returns null if room is not an entity room or is malformed.
 */
export function parseEntityRoom(room: string): { tenantId: string; module: string; entity: string } | null {
  if (!isEntityRoom(room)) return null
  // entity:{tenantId}:{module}.{entity}
  const rest = room.slice(7) // remove 'entity:'
  const colonIndex = rest.indexOf(':')
  if (colonIndex === -1 || colonIndex === 0) return null
  const tenantId = rest.slice(0, colonIndex)
  const key = rest.slice(colonIndex + 1)
  const dotIndex = key.indexOf('.')
  if (dotIndex === -1 || dotIndex === 0 || dotIndex === key.length - 1) return null
  return { tenantId, module: key.slice(0, dotIndex), entity: key.slice(dotIndex + 1) }
}
